module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAvklEQVQoU2NkQAPR0dF8XFxcaxkZGe3///+/7cOHD5GrV6/+jqyMEV1TWlpa3v///60/fPiQICAgsIKBgWH77NmzZ6BoSktLe8TAwCCLrhkP/zHcprS0tP+zZs3CsBmmGVmeOprS0tIKQabPmjWrH40NdwmGTWlpafVQTY1o7EGiiXQ/4YofXEH+nIGBIWDWrFknsaQScwYGhg2zZs2SBMnBQy81NdWPkZFxJgMDgwQW2178+/cvY86cORtBcgDMG5UiJQ1ZjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shanchu_icon.png
// module id = PGXQ
// module chunks = 1